import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Industries',
    href: '#industries'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }];
  return <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-dark/90 backdrop-blur-md py-4 border-b border-white/10' : 'bg-transparent py-6'}`} data-id="element-120">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-121">
        <a href="#" className="flex items-center" data-id="element-122">
          <img src="https://cdn.magicpatterns.com/uploads/eGy4RwjVoVa91269krSrRo/pasted-image.png" alt="Deskmayte Logo" className="h-8 w-auto brightness-0 invert" data-id="element-123" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-124">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium hover:text-brand-accent transition-colors" data-id="element-125">
              {link.name}
            </a>)}
          <a href="#contact" className="bg-brand-accent text-brand-dark px-6 py-2.5 rounded-full text-sm font-bold hover:bg-white transition-all transform hover:scale-105" data-id="element-126">
            Book Discovery Call
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-127">
          {isMobileMenuOpen ? <X data-id="element-128" /> : <Menu data-id="element-129" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="absolute top-full left-0 w-full bg-brand-dark border-b border-white/10 p-6 md:hidden" data-id="element-130">
          <div className="flex flex-col space-y-4" data-id="element-131">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-132">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-brand-accent text-brand-dark px-6 py-3 rounded-xl text-center font-bold" onClick={() => setIsMobileMenuOpen(false)} data-id="element-133">
              Book Discovery Call
            </a>
          </div>
        </motion.div>}
    </nav>;
}